import me from "models/me";
import { getStore } from "store";
import { fetchPreferredRetailers } from "../actions/brand/admin";

export default function (nextState, replace, callback) {
    const store = getStore();

    if (me.isSignedIn() && me.account_type === "nuorder") {
        store.dispatch(fetchPreferredRetailers());
        callback();
    } else {
        replace({
            pathname: "/404",
        });
        callback();
    }
}
